import { isDate } from 'lodash-es';

/**
 * Converts seconds to the closest minutes.
 * @param seconds Input value in seconds
 * @returns Closest minutes
 */
export function secondsToClosestMinutes(seconds: number) {
    return Math.max(0, seconds % 60 < 30 ? Math.floor(seconds / 60) : Math.ceil(seconds / 60));
}

/**
 * Checks if is realtime
 * @param realtime - Original realtime value
 * @param currentTime - The current time
 * @param aimedArrivalTime - The aimed arrival time
 * @param aimedDepartureTime - The aimed departure time
 * @param expectedArrivalTime - The expected arrival time
 * @param expectedDepartureTime - The expected departure time
 * @returns Whether is realtime
 */
export function isRealtime(
    realtime: boolean,
    currentTime: Date,
    aimedArrivalTime: Date,
    aimedDepartureTime: Date,
    expectedArrivalTime?: Date,
    expectedDepartureTime?: Date
): boolean {
    if (!realtime) {
        return false;
    }

    return !(
        currentTime > aimedArrivalTime &&
        currentTime > aimedDepartureTime &&
        (!isDate(expectedArrivalTime) || currentTime > expectedArrivalTime) &&
        (!isDate(expectedDepartureTime) || currentTime > expectedDepartureTime)
    );
}
